import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SignInRoute } from '@const';
import { SessionService } from '@services/session';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private sessionService: SessionService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isRegistered = this.sessionService.isRegistered();
    if (isRegistered) {
      return true;
    }

    this.router.navigate([SignInRoute.ROOT_PATH], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
